(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.svgConvert = {
    attach: function attach(context, settings) {
      this.convert();
    },

    convert: function(){
      // Get URL image and check if the file is .svg
      let urlImg = $('img.svg').attr('src');

      if(urlImg != undefined){

        urlImg 	= urlImg.replace(/\/g, /);
        var fileImg = urlImg.substring(urlImg.lastIndexOf('/') + 1);
        var typeImg= fileImg.substring(fileImg.lastIndexOf('.') + 1);

        if( typeImg == 'svg') {
          //  Replace all SVG images with inline SVG
          $('img.svg').each( function() {
            let $img = $(this);
            let imgID = $img.attr('id');
            let imgClass = $img.attr('class');
            let imgURL = $img.attr('src');

            $.get(imgURL, function(data) {

              // Get the SVG tag, ignore the rest
              let $svg = $(data).find('svg');

              // Add replaced image's ID to the new SVG
              if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
              }

              // Add replaced image's classes to the new SVG
              if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
              }

              // Remove any invalid XML tags as per http://validator.w3.org
              $svg = $svg.removeAttr('xmlns:a');
              // Replace image with new SVG
              $img.replaceWith($svg);

            });

          });

        }
        else {
          // Style for files type .png
          $('.eprc-table img.svg').css({
            'top': -2,
            'width': 'unset',
            'padding': 'unset',
            'margin': '0'
          })

          $('.eprc-table .needle-info').css({
            'height': '40px'
          })

        }

      }
    }

  };

})(jQuery, Drupal, drupalSettings);
